import styles from '@ui/components/Card/components/CardImage/CardImage.module.scss';
import Image from '@ui/components/Image/Image';
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const CardImage = ({
  image,
  aspectRatio = null,
  height = 270,
  className = null,
}) => {
  const [paddingBottom, setPaddingBottom] = useState(null);
  const style = aspectRatio
    ? { paddingBottom: `${paddingBottom}%` }
    : {
        height: `${height}px`,
      };

  useEffect(() => {
    if (aspectRatio) {
      setPaddingBottom(aspectRatio * 100);
    }
  }, [aspectRatio]);

  return (
    <div
      className={classNames(
        styles.container,
        {
          [styles.fixedHeight]: !aspectRatio,
        },
        className,
      )}
      style={style}
    >
      <Image className={styles.image} {...image} />
    </div>
  );
};

CardImage.propTypes = {
  aspectRatio: PropTypes.number,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  height: PropTypes.number,
  image: PropTypes.shape({
    src: PropTypes.string,
    srcSet: PropTypes.string,
    alt: PropTypes.string,
  }).isRequired,
};

export default CardImage;
